
export class ApConnectPost {
    ap_email: string;
    ap_password: string;
    slug_user: string;

}
